/**
 * People → Talent Acquisition → Guías de entrevista: la entrada propia del
 * Interview Plan Agent en el menú.
 *
 * **Un agente = una entrada** (Sol 28/09, y lo repitió el 02/10 cuando esto
 * había quedado como una pestaña adentro de TA Metrics): el agente de intake y
 * el de métricas ya tienen la suya, y este es un tercer agente, no una vista más
 * del dashboard.
 *
 * Audiencia (TA, 07/10/2026): Talent Acquisition (`canView`) ve y genera todas;
 * el Hiring Manager o el Bar Raiser asignado a una guía (`canInterview`) ve la
 * guía COMPLETA, pero solo las de sus búsquedas.
 */
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ClipboardList } from 'lucide-react';
import { useRegisterTaContext, useTaAccess } from '@/hooks/useTalentAcquisition';
import { TaInterviewTab } from '@/components/talent-acquisition/TaInterviewTab';

export function TaInterviewPage() {
  const { t } = useTranslation();
  const { data: access } = useTaAccess();
  // El bot del costado es el asistente de TA sobre la base entera: solo para TA.
  useRegisterTaContext('metrics', !!access?.canView);

  // La ruta la comparte con el intake (TaProtectedRoute deja pasar canView,
  // canIntake o canInterview). Las consultas de esta pantalla piden canInterview:
  // un Hiring Manager SIN guías asignadas vería la página vacía — el FORBIDDEN
  // silencioso que prohíbe la política del repo. Se lo manda a su apartado.
  if (access && !access.canInterview) return <Navigate to="/people/talent-acquisition/intake" replace />;

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center gap-3">
        <ClipboardList className="h-7 w-7 text-brand-green" />
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{t('talent_acquisition.interview.page_title')}</h1>
          <p className="text-sm text-muted-foreground">{t(access?.canView ? 'talent_acquisition.interview.intro' : 'talent_acquisition.interview.intro_interviewer')}</p>
        </div>
      </div>
      <TaInterviewTab canManage={access?.canView ?? false} canAdmin={access?.canAdmin ?? false} />
    </div>
  );
}
